import React from "react"
import { Updater, Widget, any, fromJSX } from "widgets-for-react"
import { ProductApiResponseParsed, ProductForm, ProductFormState, ProductPostageCosts, getProductValidation } from "../productFormBlock.state"
import { FormControls } from "../../../../../../../Shared/Frontend/forms"
import { capitalize } from "../../../../../../../Shared/Frontend/utils/capitalize"
import { valutaDisplay } from "../utils"
import { t } from "i18next"

const ProductPostageCostsLayout = (form: ProductPostageCosts, rootState: ProductFormState, u: (_: Updater<ProductPostageCosts>) => void) => {
  const costsValidation = getProductValidation(rootState, "sponsor")

  return <>
    <FormControls.FormRadioInGroup
      key='donation-costs-sg-0'
      name='donation-costs-sg-0'
      legend='Wil je de verzendkosten compensen?'
      disabled={false}
      required={true}
      errorMessage={costsValidation.kind == 'failed' ? costsValidation.message : undefined}
      items={[t("ProductForm:Postage.Compensate"), t("ProductForm:Postage.NonCompensate")].map((item, index) => ({
        controlId: `donation-costs-sg-${index}`,
        label: capitalize(item),
        checked: form.sponsor !== undefined && form.sponsor === !Boolean(index),
        onChange: checked => {
          u(os => {
            return {
              ...os,
              sponsor: !Boolean(index)
            }
          })
        }
      }))}
      boxed={true}
      direction='column'
    />


    {form.sponsor &&
      <p className='donation__seperator title--s'>Totaal {valutaDisplay(form.price)}</p>
    }
  </>
}

export const productPostageSegment = (form: ProductPostageCosts, rootState: ProductFormState): Widget<Updater<ProductApiResponseParsed>> => {
  return any<Updater<ProductPostageCosts>>([
    fromJSX<Updater<ProductPostageCosts>>(u => ProductPostageCostsLayout(form, rootState, u))
  ])
    .map<Updater<ProductForm>>(u => s0 => s0.kind === "product_package_costs" ? u(s0) : s0)
    .map<Updater<ProductApiResponseParsed>>(u => s0 => ({ ...s0, productForm: u(s0.productForm) }))
}
